export const imNotLeavingHimLyrics = [
  { text: "Can I keep ya", start: 28, end: 29.3 },
  { text: "Don't think I could find", start: 30, end: 34.7 },
  { text: "Someone like you", start: 35, end: 36 },
  { text: "You you you you you you", start: 36, end: 37 },
  { text: "Need to please ya", start: 37, end: 38.5},
  { text: "Oh!", start: 40, end: 42 },
  { text: "I don't wanna hide", start: 42, end: 44},
  { text: "From how I feel bout you", start: 44.5 , end: 46.8},
  { text: "I need you to hold", start: 47.7, end: 49 },
  { text: "I need you to hold", start: 49, end: 50 },
  { text: "Please don't let me go", start: 50, end: 51.5 },
  { text: "Please don't let me go", start: 51.5, end: 51.5},
  { text: "I need you to hold now", start: 51.5, end: 56.4 },
  { text: "Will you let me know", start: 56.5, end: 58.7 },
  { text: "Will you let me know", start: 58.7, end: 59.7 },
  { text: "Don't leave me alone", start: 59.7, end: 60.7},
  { text: "Don't leave me alone", start: 60.7, end: 62.3},
  { text: "I need you will you hold me down", start: 63, end: 64.9 },
  { text: "Every moment you're not next to me I lose all control", start: 66.1, end: 71.3 },
  { text: "Is it selfish of me baby to want you as my all", start: 71.3 , end: 75.9},
  { text: "The way you love me shows me what I already know", start: 76.3, end: 80.9},
  { text: "So let the record show", start: 81, end: 84.7 },
  { text: "That I'm not leavin' him", start: 85, end: 87 },
  { text: "Ba- baby", start: 87, end: 86.9},
  { text: "I almost gave up waitin for the stars to align", start: 86.9, end: 92.1},
  { text: "Sleepless nights wakin up waitin for you to send me a sign", start: 96, end: 101.8},
  { text: "That you were still mine", start: 102, end: 104.2},
  { text: "I know I said", start: 104.7, end: 106.4 },
  { text: "Things I can't take back", start: 107, end: 109 },
  { text: "If I could go back baby", start: 109, end: 112 },
  { text: "I would do that", start: 112, end: 114 },
  { text: "But if I turn back the clock", start: 114, end: 115.5},
  { text: "What happens to future us", start: 115.5, end: 118 },
  { text: "Is it worth the sacrifice", start: 118, end: 121 },
  { text: "I can't deny ny ny ny ny.", start: 121.3, end: 124.8 },
  { text: "I know right here is where you wanna be", start: 125, end: 131 },
  { text: "I need you", start: 131, end: 134 },
  { text: "In the back of your mind can you leave space for me", start: 134, end: 141.1},
  { text: "I'm right here where I wanna be", start: 141.1, end: 143},
  { text: "I'm not leavin' him", start: 143, end: 145.5},
  { text: "I'm not", start: 145.5, end: 146},
  { text: "I'm not leavin' him", start: 146, end: 147},
  { text: "No I wont hesitate", start: 147, end: 148.9 },
  { text: "My baby don't be late", start: 149, end: 152 },
  { text: "Im not leavin' him", start: 152, end: 156},
  { text: "If I had it my way", start: 156, end: 159 },
  { text: "What is, is what remains", start: 159, end: 162.2 },
  { text: "Although I lost myself", start: 163.5, end: 165.5 },
  { text: "I still I wish you well", start: 165.5, end: 168 },
  { text: "Although I lost myself", start: 168, end: 170.5 },
  { text: "I'm not leavin' him", start: 170.5, end: 174 },
  { text: "Can I go one more time", start: 182, end: 184.8},
] as const satisfies ReadonlyArray<{ readonly text: string, readonly start: number, readonly end?: number }>;
